import { Input } from 'antd';

const { Password: PasswordInput } = Input;

export default PasswordInput;
